import axios from 'axios';

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': "application/json" },
});

export class PaymentComunicationFetchAPI {
    static async initPayment(data, token) {
        const res = await server(`/pinpadremotepayment`, {
            method: "post",
            headers: {'x-access-token': token },
            data: data
        });
        return res
    } 
    
    
     static async voidPayment(data, token) {
        const res = await server(`/pinpadremotepayment`, {
            method: "post",
            headers: {'x-access-token': token },
            data: data
        });
        return res
    }

    static async getPinpadRemotePayment(pinpadRemotePaymentId, token) {
        const res = await server(`/pinpadremotepayment/${pinpadRemotePaymentId}`, {
            method: "get",
            headers: {'x-access-token': token },
        });
        return res
    }
}